export const windowHasOpener = () => {
  if (window.opener === null || window.opener === undefined) {
    return false;
  }

  return true;
};
